import { render, staticRenderFns } from "./OpportunityListPagination.vue?vue&type=template&id=0bb0f043&scoped=true&"
import script from "./OpportunityListPagination.vue?vue&type=script&lang=js&"
export * from "./OpportunityListPagination.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityListPagination.vue?vue&type=style&index=0&id=0bb0f043&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb0f043",
  null
  
)

export default component.exports